import { useToast } from '@chakra-ui/react';
import axios from 'axios';
import { useCallback } from 'react';
import * as Yup from 'yup';

import { LoginFormValues } from 'types/dashboard.d';

import {
  numericRegex,
  errorToastConfig,
} from 'packages/common-frontend/constants';
import { useUserAuthUnsafe } from '~/contexts/UserAuthProvider';

// Types
type LoginResponse = {
  id: string;
  email: string;
  userType: string;
  token: string;
};

interface LoginErrorResponse {
  message: string;
}

export const useLoginFormManagement = () => {
  const toast = useToast();
  const { login, redirectPath, setRedirectPath } = useUserAuthUnsafe();

  const handleSubmit = useCallback(
    async (formValues: LoginFormValues) => {
      try {
        const { data } = await axios.post<LoginResponse>('/login', formValues, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        login(data.token, redirectPath);
        setRedirectPath(null);
      } catch (err: any) {
        const data: LoginErrorResponse = err.response.data;
        errorToastConfig.title = data.message;
        toast(errorToastConfig);
      }
    },
    [login, redirectPath, setRedirectPath, toast],
  );

  const formValidation = Yup.object().shape({
    email: Yup.string()
      .lowercase()
      .email('Must be a valid email')
      .required('Required'),
    password: Yup.string()
      .matches(numericRegex, 'one number required')
      .min(8, 'Minimum 8 characters required')
      .required('Required'),
  });

  const initialValues: LoginFormValues = {
    email: '',
    password: '',
  };

  return {
    handleSubmit,
    initialValues,
    formValidation,
  };
};
